import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Formik, Form, ErrorMessage } from 'formik';

import FloatingLabel from "floating-label-react";
import "floating-label-react/styles.css";

import { addStreamlineAccount } from '../actions'
import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';
import { AddStreamlineAccountValidation } from './validation';

const mapStateToProps = state => ({
  errors: state.Global.errors,
  successes: state.Global.successes
});

class StreamlineAccountForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: {
        token_key: '',
        token_secret: '',
        advertiserId: '',
        advertiser_name: ''
      }
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = values => {
    const { dispatch } = this.props;
    dispatch(addStreamlineAccount(values));
  }

  render() {
    return (
      <div className="main-container streamline-accout-pg">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <Formik
            initialValues={this.state.initialValues}
            validationSchema={AddStreamlineAccountValidation}
            onSubmit={this.onSubmit}>
            {formProps => (
              <Form className='streamline-account-page'>
                <div className="form-section">
                  <h3 className='title'>Streamline Account</h3>
                  <div className="form-group">
                    <FloatingLabel
                      type="text"
                      id="name"
                      className="form-control"
                      name="advertiser_name"
                      placeholder="Advertiser Name"
                      value={formProps.values.advertiser_name}
                      onChange={formProps.handleChange}
                    />
                    <ErrorMessage name='advertiser_name' render={msg => <div className="invalid-feedback">{msg}</div>} />
                  </div>
                  <div className="form-group">
                    <FloatingLabel
                      type="text"
                      id="name"
                      className="form-control"
                      name="advertiserId"
                      placeholder="Advertiser ID"
                      value={formProps.values.advertiserId}
                      onChange={formProps.handleChange}
                    />
                    <ErrorMessage name='advertiserId' render={msg => <div className="invalid-feedback">{msg}</div>} />
                  </div>
                  <div className="form-group">
                    <FloatingLabel
                      type="text"
                      id="token_key"
                      className="form-control"
                      name="token_key"
                      placeholder="Token Key"
                      value={formProps.values.token_key}
                      onChange={formProps.handleChange}
                    />
                    <ErrorMessage name='token_key' render={msg => <div className="invalid-feedback">{msg}</div>} />
                  </div>
                  <div className="form-group">
                    <FloatingLabel
                      type='text'
                      id="token_secret"
                      placeholder="Token Secret"
                      name="token_secret"
                      className="form-control password-control"
                      value={formProps.values.token_secret}
                      onChange={formProps.handleChange}
                    />
                    <ErrorMessage name='token_secret' render={msg => <div className="invalid-feedback">{msg}</div>} />
                  </div>
                  <div className="combo-button">
                    <div className="signin-button">
                      <button type="submit" className="btn primary">Save</button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(StreamlineAccountForm));
